/**
 * Formatea un string a formato RUT chileno estándar (12.345.678-9).
 * Acepta cualquier input y lo limpia automáticamente.
 */
export const formatRut = (value: string): string => {
  // Quitar todo excepto dígitos y K/k
  let clean = value.replace(/[^0-9kK]/g, "").toUpperCase();

  if (clean.length === 0) return "";

  // Separar cuerpo y dígito verificador
  const dv = clean.slice(-1);
  const body = clean.slice(0, -1);

  if (body.length === 0) return dv;

  // Agregar puntos al cuerpo
  const formatted = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return `${formatted}-${dv}`;
};
